import { Box, type BoxProps } from "@drone-js/core";
import lottie, { type AnimationItem } from "lottie-web/build/player/lottie_light.min";
import { type FunctionComponent, useEffect, useRef } from "react";

export interface LottiePlayerProps {
    path: string;
    isLoop?: boolean;
    isPlaying?: boolean;
    speed?: number;
    containerProps?: BoxProps;
}

export const LottiePlayer: FunctionComponent<LottiePlayerProps> = ({
    path,
    isLoop = true,
    isPlaying = true,
    speed = 1,
    containerProps = {},
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const animationRef = useRef<AnimationItem | null>(null);

    useEffect(() => {
        if (!containerRef.current) return () => {};
        const animation = lottie.loadAnimation({
            container: containerRef.current,
            renderer: "svg",
            loop: isLoop,
            autoplay: isPlaying,
            path,
        });
        animation.setSpeed(speed);
        animationRef.current = animation;

        return () => {
            animation.destroy();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    useEffect(() => {
        animationRef.current?.setLoop(isLoop);
    }, [isLoop]);

    useEffect(() => {
        if (isPlaying) {
            animationRef.current?.play();
        } else {
            animationRef.current?.pause();
        }
    }, [isPlaying]);

    useEffect(() => {
        animationRef.current?.setSpeed(speed);
    }, [speed]);

    return <Box ref={containerRef} {...containerProps} />;
};
